var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5011 12.2332C22.5011 11.3699 22.4296 10.7399 22.2749 10.0865H12.2153V13.9832H18.1201C18.0011 14.9516 17.3582 16.4099 15.9296 17.3898L15.9095 17.5203L19.0902 19.935L19.3106 19.9565C21.3344 18.1249 22.5011 15.4298 22.5011 12.2332Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2147 22.4999C15.1076 22.4999 17.5361 21.5665 19.31 19.9565L15.929 17.3898C15.0242 18.0081 13.8099 18.4398 12.2147 18.4398C9.38145 18.4398 6.97669 16.6081 6.11947 14.0765L5.99382 14.0869L2.68656 16.5953L2.64331 16.7131C4.4052 20.1431 8.02425 22.4999 12.2147 22.4999Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11973 14.0767C5.89354 13.4234 5.76264 12.7234 5.76264 12.0001C5.76264 11.2767 5.89354 10.5767 6.10783 9.9234L6.10183 9.7842L2.75312 7.2356L2.64356 7.28667C1.9174 8.71005 1.50073 10.3084 1.50073 12.0001C1.50073 13.6917 1.9174 15.29 2.64356 16.7134L6.11973 14.0767Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2148 5.55997C14.2267 5.55997 15.5838 6.41164 16.3577 7.12335L19.3814 4.23C17.5244 2.53834 15.1076 1.5 12.2148 1.5C8.02425 1.5 4.4052 3.85665 2.64331 7.28662L6.10759 9.92332C6.97672 7.39166 9.38145 5.55997 12.2148 5.55997Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.89d5f7a6c6dce0f6f46fdc2cc8007cf0.svg";
export { ForwardRef as ReactComponent };